<template>
  <div class="trbo-a-top-message">
    <h3 class="trbo-a-top-message__title">
      {{ title }}
    </h3>
    <!-- eslint-disable vue/no-v-html -->
    <div v-if="description" class="trbo-a-top-message__description" @click="handleDescriptionClick" v-html="sanitizedDescription" />
    <!-- eslint-enable -->
  </div>
</template>

<script>
// @flow

import { linkify, sanitizedMarkup } from '../../../../common/utils'

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    }
  },
  computed: {
    sanitizedDescription () {
      let description = this.description
      description = description.replace(/\n/g, '\\n')
      return linkify(sanitizedMarkup(description))
    }
  },
  methods: {
    handleDescriptionClick ({ target }: any) {
      if (target.nodeName === 'A') {
        this.$emit('link-from-message-click', target.href)
      }
    }
  }
}

</script>

<style scoped src="./top-message.scss" />
